var module = angular.module('octopusApp.tasks');

module.factory('taskState', taskState);

function taskState() {
    return {
        statesThatCanBeModified: ["Success", "Failed", "Canceled"]
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/services/task_state.js
// module id = 1311708429216713
// module chunks = 1